import Vue from 'vue'

import { addCustomWidgetSchema } from '@/components/form-designer/widget-panel/widgetsConfig'
// 注册属性设置组件
import * as PERegister from '@/components/form-designer/setting-panel/propertyRegister'
// 生成组件属性设置
import * as PEFactory from '@/components/form-designer/setting-panel/property-editor-factory'

import field from "@/extension/h5/field"

addCustomWidgetSchema({
  type: 'field',
  icon: 'alert',
  formItemFlag: true,
  options: {
    name: '',
    label: '文本',
    columnWidth: '200px',
    required: false,
    labelWidth: '110',
    labelHidden: true,
    labelAlign: 'label-right-align',
    placeholder: '',
    textAlign: "left",//文字对齐方式
    defaultValue: '',
    placeholder: '',
    columnWidth: '200px',
    fontWeight: '',
    readonly: false,
    disabled: false,
    hidden: false,
    showPassword: false,
    requiredHint: '',
    validation: '',
    validationHint: '',
    //-------------------
    customClass: '',  //自定义css类名
    //-------------------
    onCreated: '',
    onMounted: '',
    onChange: '',
    onBlur: '',
  }
})  //加载组件Json Schema

Vue.component(field.name, field)  //注册组件